import { ReactComponent as IconMenu } from "@/assets/svgs/on-boarding-action-icon.svg";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@dextech-ai/dex-design-system';
import { useRef } from "react";
import renderMenuItem from "./MenuItems";
import PropTypes from 'prop-types';

export default function MultiLevelDropDown({
	menuList,
	hasNotifyDot = false,
	id = undefined,
}) {
	const lastEvent = useRef(null);
	const keepEvent = (e) => { lastEvent.current = e; };
	const stop = (e) => e.stopPropagation();

	return (
		<span role="none" onClickCapture={keepEvent} onKeyDownCapture={keepEvent} onClick={stop} onKeyDown={stop}>
			<DropdownMenu placement="bottomRight">
				<DropdownMenuTrigger asChild>
					<span
						data-testid="menu-btn"
						role="none"
						className="on-boarding__menu-btn"
						id={id}
					>
						<IconMenu id={id} />
						{hasNotifyDot && <div className="on-boarding__menu-btn__red-dot"></div>}
					</span>
				</DropdownMenuTrigger>
				<DropdownMenuContent>
					{menuList
						?.filter((item) => item !== undefined)
						?.map((item) => renderMenuItem(item, { id, onSelect: () => item?.onClick(lastEvent.current) }))}
				</DropdownMenuContent>
			</DropdownMenu>
		</span>
	);
}

MultiLevelDropDown.propTypes = {
	menuList: PropTypes.arrayOf(PropTypes.object).isRequired,
	hasNotifyDot: PropTypes.bool,
	id: PropTypes.string,
};
